import { z } from 'zod';
import { zodConversation, zodQuickResponse } from '../types';
import { SupportedLanguages } from './const';

export const zodVisitorDB = z.object({
  visitorId: z.string(),
  visitorName: z.string(),
  language: z.enum(SupportedLanguages),
  soundOn: z.boolean(),
  misuseRate: z.number(),
  quickResponses: z.array(zodQuickResponse),
  conversation: zodConversation,
});

export type VisitorDB = z.infer<typeof zodVisitorDB>;
